export default __webpack_public_path__ + "static/media/profile.5862dc6e.svg";